import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "page-shell" }
const _hoisted_2 = { class: "chat-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "chat-header__brand" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "chat-header__mark" }, "DC"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "chat-header__eyebrow" }, "Chat web"),
    /*#__PURE__*/_createElementVNode("h1", { class: "chat-header__title" }, "Diego Chatbot")
  ])
], -1)
const _hoisted_4 = { class: "chat-header__status" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "page-hero" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page-hero__title" }, [
    /*#__PURE__*/_createElementVNode("p", null, " Selecciona un asistente y continúa la conversación en el panel principal. ")
  ])
], -1)
const _hoisted_6 = { class: "mobile-assistant-switcher" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-assistant-switcher__label" }, "Asistente", -1)
const _hoisted_8 = { class: "mobile-assistant-switcher__active" }
const _hoisted_9 = {
  key: 0,
  class: "mobile-assistant-switcher__menu"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "chat-layout" }
const _hoisted_13 = { class: "assistant-panel" }
const _hoisted_14 = { class: "assistant-panel__header" }
const _hoisted_15 = { class: "img_cont assistant-panel__avatar" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "user_info" }
const _hoisted_18 = { class: "assistant-panel__section" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "bot-info-title" }, "Elige asistente", -1)
const _hoisted_20 = { class: "assistant-switcher" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { class: "assistant-option-copy" }
const _hoisted_24 = { class: "assistant-panel__section" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "bot-info-title" }, "Capacidades", -1)
const _hoisted_26 = { class: "bot-skills" }
const _hoisted_27 = { class: "chat-panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessagesChatComponent = _resolveComponent("MessagesChatComponent")!
  const _component_FormChatComponent = _resolveComponent("FormChatComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: _normalizeClass(["chat-header__dot", { offline: !$setup.isOnline }])
        }, null, 2),
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString($setup.activeAssistant.name), 1),
          _createElementVNode("p", null, _toDisplayString($setup.status_message), 1)
        ])
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "mobile-assistant-switcher__button",
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.toggleMobileAssistantMenu && $setup.toggleMobileAssistantMenu(...args)))
      }, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString($setup.activeAssistant.name), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["mobile-assistant-switcher__chevron", { open: $setup.isMobileAssistantMenuOpen }])
        }, " ⌄ ", 2)
      ]),
      ($setup.isMobileAssistantMenuOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.assistants, (assistant) => {
              return (_openBlock(), _createElementBlock("button", {
                key: assistant.id,
                type: "button",
                class: _normalizeClass(["mobile-assistant-switcher__item", { active: assistant.id === $setup.activeAssistant.id }]),
                onClick: ($event: any) => ($setup.selectAssistantAndCloseMenu(assistant.id))
              }, [
                _createElementVNode("img", {
                  src: assistant.avatar,
                  alt: assistant.name,
                  class: "mobile-assistant-switcher__avatar"
                }, null, 8, _hoisted_11),
                _createElementVNode("span", null, [
                  _createElementVNode("strong", null, _toDisplayString(assistant.name), 1),
                  _createElementVNode("small", null, _toDisplayString(assistant.description), 1)
                ])
              ], 10, _hoisted_10))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("aside", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", {
              src: $setup.activeAssistant.avatar,
              alt: $setup.activeAssistant.name,
              class: "rounded-circle user_img"
            }, null, 8, _hoisted_16),
            _createElementVNode("span", {
              class: _normalizeClass(["online_icon", { offline: !$setup.isOnline }])
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h1", null, _toDisplayString($setup.activeAssistant.name), 1),
            _createElementVNode("p", null, _toDisplayString($setup.status_message), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.assistants, (assistant) => {
              return (_openBlock(), _createElementBlock("button", {
                key: assistant.id,
                type: "button",
                class: _normalizeClass(["assistant-option", { active: assistant.id === $setup.activeAssistant.id }]),
                onClick: ($event: any) => ($setup.selectAssistant(assistant.id))
              }, [
                _createElementVNode("img", {
                  src: assistant.avatar,
                  alt: assistant.name,
                  class: "assistant-option-avatar"
                }, null, 8, _hoisted_22),
                _createElementVNode("span", _hoisted_23, [
                  _createElementVNode("strong", null, _toDisplayString(assistant.name), 1),
                  _createElementVNode("small", null, _toDisplayString(assistant.description), 1)
                ])
              ], 10, _hoisted_21))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activeAssistant.skills, (skill) => {
              return (_openBlock(), _createElementBlock("span", {
                key: skill,
                class: "skill-tag"
              }, _toDisplayString(skill), 1))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_27, [
        _createVNode(_component_MessagesChatComponent, {
          history_messages: $setup.messages,
          reset_token: $setup.assistantResetToken,
          session_token: $setup.sessionToken,
          session_id: $setup.sessionId,
          assistant_id: $setup.activeAssistant.id
        }, null, 8, ["history_messages", "reset_token", "session_token", "session_id", "assistant_id"]),
        _createVNode(_component_FormChatComponent, {
          session_id: $setup.sessionId,
          session_token: $setup.sessionToken,
          reset_token: $setup.assistantResetToken,
          assistant_id: $setup.activeAssistant.id,
          onMessagesent: $setup.handleMessageSent
        }, null, 8, ["session_id", "session_token", "reset_token", "assistant_id", "onMessagesent"])
      ])
    ])
  ]))
}